import styled from 'styled-components';
import theme from '../../styles/theme';

type SpacingType =
  | '0'
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11';

interface DividerProps {
  variant: 'none' | 'primary' | 'secondary' | 'neutral' | 'warning' | 'success';
  modifier: 'regular' | 'weak';
  margin?:
    | SpacingType
    | {
        top?: SpacingType;
        left?: SpacingType;
        right?: SpacingType;
        bottom?: SpacingType;
      }
    | string;
}

const getMarginCard = (margin) =>
  typeof margin === 'object'
    ? Object.keys(margin)
        .map(
          (space) =>
            `margin-${space}: ${theme.spacing[`spacing-${margin[space]}`]};`
        )
        .join(' ')
    : `margin: ${margin}`;

const getVariantCard = (variant, modifier) =>
  variant === 'none'
    ? 'background: "none"'
    : `background: ${theme.colors[variant].bg[modifier]}; `;

const Collapsable = styled.div<DividerProps>`
  ${({ variant, modifier }) => variant && getVariantCard(variant, modifier)}
  ${({ margin }) => margin && getMarginCard(margin)};
  ${({ borderRadius, borderRadiusAmount }) =>
    borderRadius && getBorderRadiusCard(borderRadius, borderRadiusAmount)}
  ${({ boxShadow }) => boxShadow && getElevationCard(boxShadow)}
  ${({ disabled }) =>
    disabled &&
    `
    background: ${theme.colors.neutral.bg.regular};`}

  ${({ width }) =>
    width &&
    `
    width: ${width};
  `}
  ${({ height }) =>
    height &&
    `
    height: ${height};
  `}
`;

export { Collapsable };
